export interface ForbiddenJewel {
  name: string;        // passive node name (e.g. "Nine Lives")
  ascendancy: string;  // e.g. "Necromancer"
  baseClass: string;   // e.g. "Witch"
  type: "flame" | "flesh";
  cost: number;
  costChaos: number;
  count: number;
  icon?: string;
}

export async function fetchForbiddenJewels(league = "Allflame"): Promise<ForbiddenJewel[]> {
  const res = await fetch(`/api/jewels?league=${encodeURIComponent(league)}`);
  const data = await res.json();
  const lines: any[] = data.lines ?? [];

  const results: ForbiddenJewel[] = [];

  for (const raw of lines) {
    const variant: string = raw.variant ?? "";
    if (!variant.includes("Forbidden Flame") && !variant.includes("Forbidden Flesh")) continue;

    const meta = raw.metadata ?? {};
    results.push({
      name:       meta.passiveName ?? raw.name ?? "Unknown",
      ascendancy: meta.ascendancy  ?? "Unknown",
      baseClass:  meta.baseClass   ?? "",
      type:       variant.includes("Forbidden Flame") ? "flame" : "flesh",
      cost:       raw.divineValue  ?? 0,
      costChaos:  raw.chaosValue   ?? 0,
      count:      raw.count        ?? 0,
      icon:       raw.icon,
    });
  }

  results.sort((a, b) => b.cost - a.cost);
  return results;
}
